import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import IndexedSearchForm from '../components/indexed-search-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const IndexedSearchPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} une recherche indexée`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/recherches-indexees"
            theme="danger"
          />
        </div>

        <IndexedSearchForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default IndexedSearchPage;
